// Region ID-s stay same in every env.
export enum RegionId {
  ESTONIAN_REGION_ID = "1001",
  LATVIAN_REGION_ID = "1002",
  LITHUANIAN_REGION_ID = "1003",
  FINLAND_REGION_ID = "1004",
}
